import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import stickerMakerApi from '../../api/stickerMakerApi';
import { ReportInterface } from "../../store/sticker_maker/reportsSlice";
import { usersEntity } from "./usersActions";
import { stickerPackEntity, stickerPacksEntity } from "./stickerPacksActions";
import { UserInterface} from "../../store/sticker_maker/usersSlice";
import { StickerPackInterface } from "../../store/sticker_maker/stickerPacksSlice";

const PREFIX = 'sticker_maker';

const processStrategy = (value: any) => {
  return {
    ...value
  };
}

const reportsEntity = new schema.Entity(
  'reports',
  {
    user: usersEntity,
    active_user: usersEntity,
    sticker_pack: stickerPacksEntity,
  },
  {
    processStrategy
  }
);

const reportEntity = new schema.Entity(
  'report',
  {
    user: usersEntity,
    active_user: usersEntity,
    sticker_pack: stickerPackEntity,
  },
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      user: { [key: string]: UserInterface };
      active_user: { [key: string]: UserInterface };
      sticker_pack: { [key: string]: StickerPackInterface };
      report: ReportInterface;
    }
  >(response.data.report, reportEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized  = normalize<
    any,
    {
      reports: { [key: string]: ReportInterface },
      users: { [key: string]: UserInterface };
      active_users: { [key: string]: UserInterface };
      sticker_packs: { [key: string]: StickerPackInterface };
    }
    >(response.data.reports, [reportsEntity]);

  return {
    reports: normalized.entities?.reports || {},
    users: normalized.entities.users || {},
    active_users: normalized.entities.active_users || {},
    sticker_packs: normalized.entities.sticker_packs || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchReports = createAsyncThunk(
  `${PREFIX}_reports/fetchReports`,
  async (params: object = {}) => {
    const response = await stickerMakerApi.get(`/onesky/reports`, { params })
    return normalizeCollection(response);
  }
);

export const fetchReport = createAsyncThunk(
  `${PREFIX}_reports/fetchReport`,
  async (id: number | string) => {
    const response = await stickerMakerApi.get(`/onesky/reports/${id}`);
    return normalizeInstance(response);
  }
);

export const updateReport = createAsyncThunk(
  `${PREFIX}_reports/updateReport`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await stickerMakerApi.patch(`/onesky/reports/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyReport = createAsyncThunk(
  `${PREFIX}_reports/destroyReport`,
  async (id: number) => {
    await stickerMakerApi.delete(`/onesky/reports/${id}`);
    return { id: id };
  }
);
